import React from 'react';
import Layout from '../components/common/Layout';

const PageNotFound = () => {
  return (
    <Layout>
      <h2>404</h2>
      <p>Page Not Found</p>
    </Layout>
  );
};

export default PageNotFound;
